import { render, staticRenderFns } from "./MemberPropertyAlertForm.vue?vue&type=template&id=4f58fbbd"
import script from "./MemberPropertyAlertForm.vue?vue&type=script&lang=js"
export * from "./MemberPropertyAlertForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports